export const getConfig = (i18n) => ({
  tableColumns: [
    {
      id: 'sn',
      disablePadding: false,
      label: i18n.t('camera.camera_serial_no'),
      needSorting: false
    },
    {
      id: 'cameraStatus',
      disablePadding: false,
      label: i18n.t('camera.cameraStatus'),
      needSorting: false
    },
    {
      id: 'simState',
      disablePadding: false,
      label: i18n.t('camera.simState'),
      needSorting: false
    },
    {
      id: 'lastConnectTime',
      disablePadding: false,
      label: i18n.t('camera.lastConnectTime'),
      needSorting: false
    },
    {
      id: 'lastDisconnectTime',
      disablePadding: false,
      label: i18n.t('camera.lastDisconnectTime'),
      needSorting: false
    }
  ]
});
